/* eslint-disable @typescript-eslint/no-explicit-any */

import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

type SuscribirViajesResponse = {
  state: number;
  value: any;
};

export const suscribirViajes = async (todosValue: boolean): Promise<any> => {
  try {
    const res = await apiClient.post<SuscribirViajesResponse>(
      Endpoints.SuscribirViajes,
      { todos: todosValue }
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
